import { useUpdateOrderMutation } from '../../api/api-hooks';
import { OrderForm } from './ordersTypes';

const useOrderItemUpdater = () => {
  const [editOrder] = useUpdateOrderMutation();
  return (item: OrderForm, id: number) => {
    if (!item.company)
      return { error: { data: { message: 'Missing required fields' } } };
    return editOrder({
      id: Number(id),
      updateOrderDto: {
        ...item,
        id: Number(id),
        companyId: item.company.id,
        quoteName: item.quoteName ? item.quoteName : null,
        quoteLink: item.quoteLink ? item.quoteLink : null,
        purchaseOrderName: item.purchaseOrderName
          ? item.purchaseOrderName
          : null,
        purchaseOrderLink: item.purchaseOrderLink
          ? item.purchaseOrderLink
          : null,
        notes: item.notes,
      },
    });
  };
};
export default useOrderItemUpdater;
